// Track menu item clicks (top menu and toolbar)
document.addEventListener('DOMContentLoaded', function() {
  // Track main navigation menu
  const topMenus = document.querySelectorAll('.list-menu.list-menu--inline');
  
  topMenus.forEach(menu => {
    const menuItems = menu.querySelectorAll(':scope > li');
    
    menuItems.forEach(item => {
      const link = item.querySelector('a');
      if (link) {
        link.addEventListener('click', function(e) {
          // Get menu item text
          const menuText = this.textContent.trim();
          const menuUrl = this.getAttribute('href');
          
          // Push to dataLayer
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'topMenuClick',
            'menuItem': menuText,
            'menuUrl': menuUrl,
            'menuType': 'main-menu'
          });
        });
      }
    });
  });
  
  // Track toolbar menu links
  const toolbarMenuItems = document.querySelectorAll('.toolbar__menu li');
  
  toolbarMenuItems.forEach(item => {
    const link = item.querySelector('a');
    if (link) {
      link.addEventListener('click', function(e) {
        // Get menu item text
        const menuText = this.textContent.trim();
        const menuUrl = this.getAttribute('href');
        
        // Push to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'toolbarMenuClick',
          'menuItem': menuText,
          'menuUrl': menuUrl,
          'menuType': 'toolbar'
        });
      });
    }
  });
});